<template>
  <div class="admin-tab">
    <v-layout justify-space-between mb-3>
      <h2>Filtrer</h2>
      <v-spacer></v-spacer>
      <v-btn class="mr-6" @click="handlePrint"
        >Imprimer l'édition administration</v-btn
      >
    </v-layout>

    <!-- Filter block -->
    <v-layout class="filters-container" mb-8 wrap>
      <v-flex sm12>
        <v-layout justify-space-between>
          <v-flex sm4>
            <v-dialog v-model="dialogDatepickerFrom" width="290px">
              <template #activator="{ on }">
                <v-text-field
                  label="Du"
                  append-icon="mdi-calendar"
                  :value="dateFrom | dateFormat"
                  @click:clear="dateFrom = null"
                  v-on="on"
                  clearable
                  single-line
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="dateFrom"
                @change="dialogDatepickerFrom = false"
              >
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm4>
            <v-dialog v-model="dialogDatepickerTo" width="290px">
              <template #activator="{ on }">
                <v-text-field
                  label="Au"
                  append-icon="mdi-calendar"
                  :value="dateTo | dateFormat"
                  @click:clear="dateto = null"
                  v-on="on"
                  clearable
                  single-line
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="dateTo"
                @change="dialogDatepickerTo = false"
              >
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm4>
            <v-btn class="mt-4" block @click="onSearch">Rechercher</v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex sm4>
            <v-select
              label="Type de date"
              :items="dateTypes"
              v-model="dateType"
              @change="cleanDate"
              filled
              hide-details
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
      v-if="dateType == 'MOLDING_BOOK'"
      :headers="headers_molding_book"
      :items="filteredProjects"
      group-by="applicator_fullname"
      fixed-header
      height="500"
      :items-per-page="300"
    >
      <!-- Moled at -->
      <template #item.created_at="{ value }">
        {{ value | dateFormat }}
      </template>

      <!-- Delivery at -->
      <template #item.real_delivery_at="{ value }">
        {{ value | dateFormat }}
      </template>

      <!-- Date fabrication -->
      <template #item.cost_calculation_date="{ value }">
        {{ value | dateFormat }}
      </template>

      <!-- Motant devis -->
      <template #item.total_amount_ht_lomaco_quotation="{ value }">
        {{ value | currency }}
      </template>

      <!-- Motant facturé -->
      <template #item.total_amount_ht_lomaco_invoice="{ value }">
        {{ value | currency }}
      </template>

      <template #group.header="{ group, items }">
        <td class="text-start" colspan="8">{{ group }}</td>
        <td class="text-start">
          Total Devis : {{ calculateTotalQuotation(items) | currency }}
        </td>
        <td class="text-start">
          Total Facturé : {{ calculateTotalInvoice(items) | currency }}
        </td>
      </template>
    </v-data-table>

    <v-layout justify-end mt-6 class="total" v-if="dateType == 'MOLDING_BOOK'">
      <v-flex sm2>
        <p>
          Total Devis :
          {{ calculateTotalQuotation(filteredProjects) | currency }}
        </p>
      </v-flex>
      <v-flex sm2>
        <p>
          Total Facturé :
          {{ calculateTotalInvoice(filteredProjects) | currency }}
        </p>
      </v-flex>
    </v-layout>

    <v-data-table
      v-if="dateType == 'CUMULATIVE_APPLICATORS'"
      :headers="headers_cumulative_applicator"
      :items="filteredCumulProjects"
      group-by="applicator_fullname"
      fixed-header
      height="500"
      :items-per-page="300"
    >
      <!-- Cout fabriqué -->
      <template #item.total_manufactured_cost="{value}">
        {{ value | currency }}
      </template>

      <!-- Total facturé -->
      <template #item.total_amount_ht_lomaco_invoice="{value}">
        {{ value | currency }}
      </template>

      <template #group.header="{ group, items }">
        <td class="text-start" colspan="2">{{ group }}</td>
        <td class="text-start" style="text-align: left !important">
          Total applicateur fabriqué :
          {{ calculateTotalCost(items) | currency }}
        </td>
        <td class="text-start" style="text-align: left !important">
          Total applicateur facturé :
          {{ calculateTotalInvoice(items) | currency }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import PrintRepo from "@/repositories/print";
  import ProjectsRepo from "@/repositories/projects";

  export default {
    name: "AdminTab",
    data() {
      return {
        // Header for molding book
        headers_molding_book: [
          {
            text: "N° Dossier",
            align: "left",
            value: "file_number"
          },

          {
            text: "Type",
            align: "left",
            value: "device_label"
          },

          {
            text: "Nom du patient",
            align: "left",
            value: "patient_fullname"
          },

          {
            text: "Opération",
            align: "left",
            value: "bracket_label"
          },

          {
            text: "Agence",
            align: "left",
            value: "agency_name"
          },

          {
            text: "Date Moulage",
            align: "left",
            value: "created_at"
          },

          {
            text: "Date fabrication",
            align: "left",
            value: "cost_calculation_date"
          },

          {
            text: "Livré le",
            align: "left",
            value: "real_delivery_at"
          },

          {
            text: "Montant Devis",
            align: "left",
            value: "total_amount_ht_lomaco_quotation"
          },

          {
            text: "Montant Facturé",
            align: "left",
            value: "total_amount_ht_lomaco_invoice"
          }
        ],

        // Header for cumulative applicator
        headers_cumulative_applicator: [
          {
            text: "Quantité",
            align: "left",
            value: "nb_projects"
          },

          {
            text: "Type",
            align: "left",
            value: "device_label"
          },

          {
            text: "Coût fabriqué",
            align: "left",
            value: "total_manufactured_cost"
          },

          {
            text: "Total facturé",
            align: "left",
            value: "total_amount_ht_lomaco_invoice"
          }
        ],

        projects: [],

        dateFrom: null,
        dialogDatepickerFrom: false,
        dateTo: null,
        dialogDatepickerTo: false,

        dateType: "MOLDING_BOOK",
        dateTypes: [
          {
            value: "MOLDING_BOOK",
            text: "Cahier des moulages"
          },
          {
            value: "CUMULATIVE_APPLICATORS",
            text: "Cumul applicateurs"
          }
        ]
      };
    },
    computed: {
      filteredProjects() {
        return this.projects.map(item => {
          item.applicator_fullname = `${item.applicator_lastname.toUpperCase()} ${
            item.applicator_firstname
          }`;

          item.patient_fullname = `${item.patient_lastname} ${item.patient_firstname}`;

          return item;
        });
      },

      filteredCumulProjects() {
        return this.projects.map(item => {
          item.applicator_fullname = `${item.lastname.toUpperCase()} ${
            item.firstname
          }`;

          return item;
        });
      }
    },
    methods: {
      /**
       * Sum prop value in an array of items
       *
       *  @param {Array} items
       */
      calculateTotalCost(items) {
        return items.reduce((a, b) => a + (b.total_manufactured_cost || 0), 0);
      },

      /**
       * Sum prop value in an array of items
       *
       *  @param {Array} items
       */
      calculateTotalQuotation(items) {
        return items.reduce(
          (a, b) => a + (b.total_amount_ht_lomaco_quotation || 0),
          0
        );
      },

      /**
       * Sum prop value in an array of items
       *
       *  @param {Array} items
       */
      calculateTotalInvoice(items) {
        return items.reduce(
          (a, b) => a + (b.total_amount_ht_lomaco_invoice || 0),
          0
        );
      },

      /**
       * Reset dates
       */
      cleanDate() {
        this.dateFrom = null;
        this.dateTo = false;
        this.projects = [];
      },

      /**
       * Search projects by date range
       */
      async onSearch() {
        const options = {
          dateType: this.dateType,
          dateFrom: this.dateFrom || null,
          dateTo: this.dateTo || new Date().toISOString().split("T")[0]
        };

        const { data } = await ProjectsRepo.fetchAdministrationProjects(
          options
        );
        this.projects = data;
      },

      // Download workshop pdf
      async handlePrint() {
        const params = {
          dateType: this.dateType,
          dateFrom: this.dateFrom || null,
          dateTo: this.dateTo || new Date().toISOString().split("T")[0]
        };

        try {
          const res = await PrintRepo.getAdministrationPdf(params);
          let blob = new Blob([res], {
            type: "application/pdf"
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);

          const date = new Date().toISOString().split("T")[0];
          const hour = new Date().toISOString().split("T")[1];
          const filename = `${date}-${hour}-administration.pdf`;

          link.download = filename;
          link.click();
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
</script>

<style lang="scss">
  .admin-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
  }
</style>
